export default __webpack_public_path__ + "assets/models/c16ebcde4a4791a082b0a1b6c80aa6e8.glb";